<template>
  <div>
    <validation-observer v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(localLogin)">
        <b-row class="mb-3 d-md-block">
          <b-col>
            <validation-provider v-slot="{ errors }" rules="required|min:1" name="Username">
              <InputText
                v-model="username"
                :errors="errors"
                :placeholder="$t('profile.signUp.main.email')"
              />
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="mb-3 d-md-block">
          <b-col>
            <validation-provider v-slot="{ errors }" rules="required|min:1" name="Password">
              <InputText
                v-model="password"
                :errors="errors"
                type="password"
                autocomplete="current-password"
                :placeholder="$t('profile.signUp.main.password')"
              />
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="mb-3 d-md-block">
          <b-col>
            <span class="forgot-text" @click="forgotPage">
              {{ $t('profile.logIn.main.forgot') }}
            </span>
          </b-col>
        </b-row>
        <recaptcha class="row justify-content-center" />
        <div class="mt-2">
          <Button width="full" color="green" :submit="true">
            {{ $t('profile.logIn.main.title') }}&nbsp;>
          </Button>
        </div>
      </b-form>
    </validation-observer>
    <ErrorSection v-if="error" :error-message="errorMessage" />
  </div>
</template>

<script>
import VeeValidate from '~/plugins/vee-validate.js';
import InputText from 'UI/InputText';
import Button from 'UI/Button';
import ErrorSection from '@/components/User/Form/ErrorSection';
export default {
  components: {
    InputText,
    Button,
    ErrorSection
  },
  data() {
    return {
      error: false,
      errorMessage: '',
      username: '',
      password: ''
    };
  },
  created() {
    VeeValidate(this.$i18n.locale);
  },
  methods: {
    async localLogin() {
      this.$emit('loading', true);
      await this.loginUser();
      this.$emit('loading', false);
    },
    async loginUser() {
      try {
        const captchaToken = await this.$recaptcha.getResponse();

        await this.$auth.loginWith('local', {
          data: { username: this.username, password: this.password, captchaToken }
        });

        this.$store.dispatch('updateUserDataIntercom');
        this.$store.commit('downloads/SET_DOWNLOAD_PERMISSION', []);
        this.$gtm.push({ event: 'LoginUser' });
        this.$emit('login');
        try {
          await this.$recaptcha.reset();
        } catch (error) {
          console.error('LOGIN', error);
        }
        this.$nuxt.refresh();
      } catch (error) {
        console.error('LOGIN', error);
        this.error = true;
        this.errorMessage =
          error.message === 'invalid_credentials'
            ? this.$t('profile.logIn.main.credentialsError')
            : this.$t('profile.logIn.main.defaultError');
      }
    },
    forgotPage() {
      this.$bvModal.hide('user-modal');
      this.$router.push({ path: this.localePath('login-forgot') });
    }
  }
};
</script>

<style lang="scss" scoped>
.forgot-text {
  cursor: pointer;
  color: $defaultColor;
}
</style>
